import { videoModalActionTypes } from '@/components/modals/videoModal/Constants';

import type { ToggleVideoModalAction, VideoModalActions, VideoModalState } from './types';

const initialState: VideoModalState = {
	open: false,
	videoId: null,
	videoUrl: null,
	onClose: null,
	autoplay: false,
};

export default function videoModalReducer(
	state = initialState,
	action: VideoModalActions,
): VideoModalState {
	switch (action.type) {
		case videoModalActionTypes.TOGGLE_VIDEO_MODAL: {
			const { data } = (action as ToggleVideoModalAction).payload;

			if (data.open === false) {
				return {
					...initialState,
					open: false,
				};
			}

			if (data.open === true) {
				return {
					...initialState,
					...data,
					open: true,
				};
			}

			return {
				...state,
				...data,
			};
		}

		default:
			return state;
	}
}
